export const PRODUCT_NAME = 'platform';
export const SENTRY_PLACEHOLDER = 'xxxxx';
export const SENTRY_REPLAY_SESSION_SAMPLE_RATE = 0;
export const SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE = 1.0;
export const SENTRY_TRACES_SAMPLE_RATE = 0.2;
